module.exports = __webpack_public_path__ + "static/img/物联网链接器.103f23b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/support-article/物联网链接器.png
// module id = 301
// module chunks = 1